import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OrganizationProfileComponent} from './organization-profile/organization-profile.component';
import {LaboratoryFormComponent} from './laboratory-form/laboratory-form.component';
import {LayoutComponent} from './layout/layout.component';
import {OrganizationResolverService} from './services/organization-resolver.service';
import {LabsResolverService} from './services/labs-resolver.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {CheckPermissionsGuardService} from '@services/guards/check-permissions.guard.service';
import {usersRoutes} from './users/users-routing.module';
import {SpecialistsResolverService} from '@providers/_resolvers/specialists-resolver.service';
import {LaboratoryResponsibleStaffTypesResolverService} from '@providers/_resolvers/laboratory-responsible-staff-types-resolver.service';
import {LaboratoryResponsibleStaffResolverService} from '@providers/_resolvers/laboratory-responsible-staff-resolver.service';

export const organizationRoutes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: '',
                redirectTo: 'profile',
                pathMatch: 'full'
            },
            {
                path: 'profile',
                component: OrganizationProfileComponent,
                canActivate: [CheckPermissionsGuardService],
                data: {
                    title: 'Настройки профиля организации',
                    permissions: [
                        UserNamespace.Permission.accessModuleOrganization,
                    ]
                },
                resolve: {
                    formValues: OrganizationResolverService
                }
            },
            {
                path: 'labs',
                component: LaboratoryFormComponent,
                canActivate: [CheckPermissionsGuardService],
                data: {
                    title: 'Настройки лаборатории',
                    permissions: [
                        UserNamespace.Permission.laboratoryUpdate,
                    ]
                },
                resolve: {
                    formValues: LabsResolverService,
                    specialists: SpecialistsResolverService,
                    responsibleStaff: LaboratoryResponsibleStaffResolverService,
                    responsibleStaffTypes: LaboratoryResponsibleStaffTypesResolverService,
                }
            },
            {
                path: 'users',
                canActivate: [CheckPermissionsGuardService],
                data:
                    {
                        title: 'Пользователи',
                        permissions: [
                            UserNamespace.Permission.organizationUser,
                        ],
                    },
                children: usersRoutes
            }
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(organizationRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class OrganizationRoutingModule {
}
